import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { PaymentStatusResponse } from "../../types/payments"
import { IBankMeta } from "../../api/interface"

type IPaymentSlice = {
  token: string | null
  id: string | null
  result: PaymentStatusResponse | null
  amount: number | null
  selectedBank?: IBankMeta | null
}

const initialState: IPaymentSlice = {
  token: null,
  id: null,
  result: null,
  amount: null,
  selectedBank: null,
}

const paymentSlice = createSlice({
  name: "paymentSlice",
  initialState,
  reducers: {
    setPaymentToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload
    },
    setPaymentId: (state, action: PayloadAction<string | null>) => {
      state.id = action.payload
    },
    setPaymentResult: (
      state,
      action: PayloadAction<PaymentStatusResponse | null>,
    ) => {
      state.result = action.payload
    },
    setPaymentAmount: (state, action: PayloadAction<number | null>) => {
      state.amount = action.payload
    },
    setSelectedBank: (state, action: PayloadAction<IBankMeta | null>) => {
      state.selectedBank = action.payload
    }
  },
})

export const {
  setPaymentToken,
  setPaymentId,
  setPaymentResult,
  setPaymentAmount,
  setSelectedBank,
} = paymentSlice.actions

export default paymentSlice.reducer
